module.exports = __webpack_public_path__ + "media/packs/images/oschad-logo-5dfc7d93093dc5f8005f8ad5526d0b6d.svg";